import React, { useMemo } from 'react';
import BlogPostCard from './BlogPostCard';
import { blogPosts } from './blogPostsData';

const BlogPosts: React.FC = () => {
  // Sort blog posts by date (newest first)
  const sortedPosts = useMemo(() => {
    return [...blogPosts].sort((a, b) => {
      // Parse dates from format "DD MMM YYYY" (e.g., "21 Jan 2026")
      const parseDate = (dateStr: string): Date => {
        const months: { [key: string]: number } = {
          'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
          'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
        };
        const parts = dateStr.split(' ');
        const day = parseInt(parts[0]);
        const month = months[parts[1]];
        const year = parseInt(parts[2]);
        return new Date(year, month, day);
      };
      
      const dateA = parseDate(a.date);
      const dateB = parseDate(b.date);
      return dateB.getTime() - dateA.getTime(); // Descending order (newest first)
    });
  }, []);

  return (
    <section className="bg-[#F3F4F6] py-16 md:py-20">
      <div className="mx-auto px-4 md:px-10 lg:px-32 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sortedPosts.map((post) => (
            <BlogPostCard
              key={post.id}
              image={post.image}
              title={post.title}
              description={post.description}
              author={post.author}
              authorImage={post.authorImage}
              date={post.date}
              link={post.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPosts;

